import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import {
  ShiftWorkTimeReport,
  TypeOrmFindManyOptionsWithAgreements,
} from '@wilson/interfaces';
import { stringify } from 'qs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkTimeManagementServiceGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  public getWorkTimeReports(
    options: TypeOrmFindManyOptionsWithAgreements,
  ): Observable<ShiftWorkTimeReport[]> {
    const params = stringify({ ...options });
    return this.httpClient.get<ShiftWorkTimeReport[]>(
      `${this.config.host}/shift-exports?${params}`,
    );
  }
}
